import { Component } from "react";
import styles from "./CartBorder.module.scss";

class CartBorder extends Component {
  render() {
    return <div className={styles.cartBorder}></div>;
  }
}

export default CartBorder;
